/**
 * Typography Theme Engine — moods mapped onto the Design Engine's pairings.
 *
 * A typography theme picks which Design Engine font pairing expresses it and
 * which type scales suit it. Categories reference themes, never pairings,
 * so new pairings added to the Design Engine later only need a theme update
 * here — no category changes.
 */

export const TYPOGRAPHY_THEMES = {
  modern: {
    id: 'modern', name: 'Modern',
    pairingId: 'modern-sans',
    scales: ['balanced', 'dramatic'],
  },
  elegant: {
    id: 'elegant', name: 'Elegant',
    pairingId: 'elegant-serif',
    scales: ['subtle', 'balanced'],
  },
  bold: {
    id: 'bold', name: 'Bold',
    pairingId: 'bold-display',
    scales: ['balanced', 'dramatic'],
  },
  friendly: {
    id: 'friendly', name: 'Friendly',
    pairingId: 'friendly-round',
    scales: ['subtle', 'balanced'],
  },
};

export const listTypographyThemes = () =>
  Object.values(TYPOGRAPHY_THEMES).map(({ id, name }) => ({ id, name }));

export const getTypographyTheme = (id) => {
  const theme = TYPOGRAPHY_THEMES[id];
  if (!theme) throw new Error(`Unknown typography theme "${id}"`);
  return theme;
};
